import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { changeNumberColumns } from "../../../../constants/lineListColumns";
import { __getChangeNumber } from "../../../../api/sim";

const COPY_KEYS = [
  "id",
  "batch_id",
  "iccid",
  "status",
  "old_msisdn",
  "new_msisdn",
  "last_updated",
];

const ClientChangeNumberBatch = () => (
  <BatchDetail
    title="Change Number"
    apiGet={__getChangeNumber}
    columnsFactory={(ctx) => changeNumberColumns({ ...ctx, showAreaZip: true })}
    copyKeys={COPY_KEYS}
    exportAction="change_number"
    retryOperation="change_number"
    showCheckStatus
    checkStatusOperation="change_number"
    showTerminate
    terminateOperation="change_number"
  />
);

export default ClientChangeNumberBatch;
